import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';
import { useRef } from 'react';

export default function LatestUpdates() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            新作速递
          </h2>
          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 cursor-pointer hover:border-foreground-500 hover:text-foreground-950 transition-colors"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>

        {/* Horizontal scroll container */}
        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scroll-smooth pb-4 -mx-2 px-2 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none' }}
        >
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex-shrink-0 w-[260px] snap-start group cursor-pointer"
              data-product-shop=""
            >
              <div className="relative rounded-xl overflow-hidden bg-background-50">
                {/* Tag for first card */}
                {index === 0 && (
                  <span className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-md bg-foreground-950 text-background-50 text-xs font-medium">
                    今日更新
                  </span>
                )}
                {/* Cover image */}
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={`${comic.title} - ${comic.category}`}
                    title={`${comic.title}漫画 - 韩漫在线观看`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                {/* Info */}
                <div className="p-4">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap overflow-hidden text-ellipsis">
                    {comic.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-600">{comic.latestChapter}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{comic.updateDate}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}